import React from 'react';

import { useIntl } from 'react-intl';

import { AutocompleteAddressInput } from 'components/autocomplete-address-input';
import { useGeolocation } from 'state/geolocation';

import { ISearchBarProps } from './types';

export const SearchBar = ({ defaultValue, onAddressSelected }: ISearchBarProps) => {
  const { formatMessage } = useIntl();
  const { resetCoordinatesManual, setManualAddress, manualAddress } = useGeolocation();

  return (
    <AutocompleteAddressInput
      required
      value={manualAddress || defaultValue}
      onInputValueChange={value => {
        setManualAddress(value?.toString() || '');
        if (!value) {
          resetCoordinatesManual();
        }
      }}
      onAddressSelected={(address, placeId, placeData) =>
        onAddressSelected?.(address, placeId, placeData)
      }
      label={formatMessage({ id: 'yourAddress' })}
      testID="storelocator-autocomplete"
      inputCustomProps={{ backgroundColor: 'white' }}
    />
  );
};
